{
  "general": {
    "primary": {
      "label": "",
      "data": {
        "sourceName": {
          "SRC": "general",
          "Label": "Source Name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        },
        "sequenceNumber": {
          "SRC": "general",
          "Label": "Sequence Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        },
        "ingestSequence": {
          "SRC": "general",
          "Label": "Ingest Sequence",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        },
        "sourceId": {
          "SRC": "general",
          "Label": "SourceId",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {
      "data": {
        "terminalDomain": {
          "SRC": "general",
          "Label": "Terminal Domain",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "siteDomain": {
          "SRC": "general",
          "Label": "Site Domain",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "extra-Timezone": {
          "SRC": "general",
          "Label": "Timezone",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "syncTimestamp": {
          "SRC": "general",
          "Label": "Sync Timestamp",
          "Type": "Timestamp",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "terminalReference": {
          "SRC": "general",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "ingestTopic": {
          "SRC": "general",
          "Label": "Ingest Topic",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "body": {
          "SRC": "general",
          "Label": "Body",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "siteReference": {
          "SRC": "general",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "parseErrors": {
          "SRC": "general",
          "Label": "Parse Errors",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "ingestTime": {
          "SRC": "general",
          "Label": "Ingest Time",
          "Type": "Timestamp",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "active": {
          "SRC": "general",
          "Label": "Active",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "@timestamp": {
          "SRC": "general",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "timestamp": {
          "SRC": "general",
          "Label": "Timestamp",
          "Type": "Timestamp",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 1
        },
        "@version": {
          "SRC": "general",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "id": {
          "SRC": "general",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        },
        "serialNumber": {
          "SRC": "general",
          "Label": "Serial Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1
        }
      }
    }
  },
  "APP": {
    "primary": {
      "label": "",
      "data": {
        "APP-9F06": {
          "SRC": "APP",
          "Label": "EMV - AID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Authorisation Code": {
          "SRC": "APP",
          "Label": "Authorisation Code",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Authorised Amount": {
          "SRC": "APP",
          "Label": "Authorised Amount",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-BKM Result": {
          "SRC": "APP",
          "Label": "BKM Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Brand": {
          "SRC": "APP",
          "Label": "Brand",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Config Error": {
          "SRC": "APP",
          "Label": "Config Error",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Config File": {
          "SRC": "APP",
          "Label": "Config File",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Config Type": {
          "SRC": "APP",
          "Label": "Config Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Count": {
          "SRC": "APP",
          "Label": "Count",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-D1": {
          "SRC": "APP",
          "Label": "D1",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-D2": {
          "SRC": "APP",
          "Label": "D2",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-D3": {
          "SRC": "APP",
          "Label": "D3",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DC": {
          "SRC": "APP",
          "Label": "DC",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DD": {
          "SRC": "APP",
          "Label": "DD",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DE": {
          "SRC": "APP",
          "Label": "DE",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Error": {
          "SRC": "APP",
          "Label": "Error",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-HID": {
          "SRC": "APP",
          "Label": "HID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Host Result": {
          "SRC": "APP",
          "Label": "Host Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-50": {
          "SRC": "APP",
          "Label": "EMV - Application Label",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-5A": {
          "SRC": "APP",
          "Label": "EMV - PAN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*****-Only for proprietary, maybe only use other tag"
        },
        "APP-5FE102": {
          "SRC": "APP",
          "Label": "PP - Modeld",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-5FE310": {
          "SRC": "APP",
          "Label": "PP - KSN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "Maybe store all KSNs in the same DFCA16 tag (terminal change)"
        },
        "APP-82": {
          "SRC": "APP",
          "Label": "EMV - AIP",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-95": {
          "SRC": "APP",
          "Label": "EMV - TVR",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9A": {
          "SRC": "APP",
          "Label": "EMV - Transaction Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9B": {
          "SRC": "APP",
          "Label": "EMV - TSI",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9C": {
          "SRC": "APP",
          "Label": "EMV - Transaction Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F12": {
          "SRC": "APP",
          "Label": "EMV - Application Preferred Name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F15": {
          "SRC": "APP",
          "Label": "EMV - Merchant Category Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F1A": {
          "SRC": "APP",
          "Label": "EMV - Terminal Country Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F21": {
          "SRC": "APP",
          "Label": "EMV - Transaction Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F35": {
          "SRC": "APP",
          "Label": "EMV - Terminal Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-9F53": {
          "SRC": "APP",
          "Label": "EMV - Contactless Card Verification Result",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "APP-Currency Code": {
          "SRC": "APP",
          "Label": "Currency Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-D4": {
          "SRC": "APP",
          "Label": "D4",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-D5": {
          "SRC": "APP",
          "Label": "D5",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*-not necessarily consistent"
        },
        "APP-DF Name": {
          "SRC": "APP",
          "Label": "DF Name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA09": {
          "SRC": "APP",
          "Label": "Item ref",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA0A": {
          "SRC": "APP",
          "Label": "Brand name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA0E": {
          "SRC": "APP",
          "Label": "Transaction timestamp",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA1B": {
          "SRC": "APP",
          "Label": "Scan display message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA4A": {
          "SRC": "APP",
          "Label": "Floor limit exceeded",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA4B": {
          "SRC": "APP",
          "Label": "Kernel type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA4C": {
          "SRC": "APP",
          "Label": "Authorization type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA5C": {
          "SRC": "APP",
          "Label": "Proprietary token",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCA70": {
          "SRC": "APP",
          "Label": "Deferred auth",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFCC02": {
          "SRC": "APP",
          "Label": "Offline type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD002": {
          "SRC": "APP",
          "Label": "EMS - EMV Response data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD006": {
          "SRC": "APP",
          "Label": "EMS - Merchant ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD007": {
          "SRC": "APP",
          "Label": "EMS - Approval code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD008": {
          "SRC": "APP",
          "Label": "EMS - Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD009": {
          "SRC": "APP",
          "Label": "EMS - Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-DFD00A": {
          "SRC": "APP",
          "Label": "EMS - Reversal amount",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Data": {
          "SRC": "APP",
          "Label": "Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Deferred Auth Flag": {
          "SRC": "APP",
          "Label": "Deferred Auth Flag",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Host Txn ID": {
          "SRC": "APP",
          "Label": "Host Txn ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-ID": {
          "SRC": "APP",
          "Label": "ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-IFD Serial Number": {
          "SRC": "APP",
          "Label": "IFD Serial Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-IFD Type": {
          "SRC": "APP",
          "Label": "IFD Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Init Result": {
          "SRC": "APP",
          "Label": "Init Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Link": {
          "SRC": "APP",
          "Label": "Link",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Masked PAN": {
          "SRC": "APP",
          "Label": "Masked PAN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Message": {
          "SRC": "APP",
          "Label": "Message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Result": {
          "SRC": "APP",
          "Label": "Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-SAM App ID": {
          "SRC": "APP",
          "Label": "SAM App ID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Stored sessions": {
          "SRC": "APP",
          "Label": "Stored sessions",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Transaction Currency Exponent": {
          "SRC": "APP",
          "Label": "Transaction Currency Exponent",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Txn ID": {
          "SRC": "APP",
          "Label": "Txn ID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Txn Time": {
          "SRC": "APP",
          "Label": "Txn Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Txn Type": {
          "SRC": "APP",
          "Label": "Txn Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Type": {
          "SRC": "APP",
          "Label": "Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "APP-Unpredictable Number": {
          "SRC": "APP",
          "Label": "Unpredictable Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {
      "data": {
        "APP-57": {
          "SRC": "APP",
          "Label": "EMV - Track 2 equivalent data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 1,
          "Notes": "******-Sensitive"
        },
        "APP-5FE311": {
          "SRC": "APP",
          "Label": "PP - Encrypted card holder data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-7FE320": {
          "SRC": "APP",
          "Label": "PP - Clearing record amount",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-8E": {
          "SRC": "APP",
          "Label": "EMV - CVM",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F07": {
          "SRC": "APP",
          "Label": "EMV - Application Usage Control",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F09": {
          "SRC": "APP",
          "Label": "EMV - Application Version Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F0D": {
          "SRC": "APP",
          "Label": "EMV - Issuer Action Code - Default",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 1,
          "Overview Detail Label": 1,
          "Show missing": 1,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F0E": {
          "SRC": "APP",
          "Label": "EMV - Issuer Action Code - Denial",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F0F": {
          "SRC": "APP",
          "Label": "EMV - Issuer Action Code - Online",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F10": {
          "SRC": "APP",
          "Label": "EMV - Issuer Application Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F11": {
          "SRC": "APP",
          "Label": "EMV - Issuer Code Table Index",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F26": {
          "SRC": "APP",
          "Label": "EMV - Application Cryptogram",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F27": {
          "SRC": "APP",
          "Label": "EMV - Cryptogram Information Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F33": {
          "SRC": "APP",
          "Label": "EMV - Terminal Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F34": {
          "SRC": "APP",
          "Label": "EMV - CVM Results",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F36": {
          "SRC": "APP",
          "Label": "EMV - Application Transaction Counter (ATC)",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F39": {
          "SRC": "APP",
          "Label": "EMV - Point-of-Service (POS) Entry Mode",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F40": {
          "SRC": "APP",
          "Label": "EMV - Additional Terminal Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-9F66": {
          "SRC": "APP",
          "Label": "EMV - Terminal Transaction Qualifiers",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "APP-9F6E": {
          "SRC": "APP",
          "Label": "EMV - Enhanced Contactless Reader Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "APP-DFCA0D": {
          "SRC": "APP",
          "Label": "Auth entity",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA0F": {
          "SRC": "APP",
          "Label": "Expiry date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA12": {
          "SRC": "APP",
          "Label": "ICR allowed",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA1D": {
          "SRC": "APP",
          "Label": "App BHV",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA2C": {
          "SRC": "APP",
          "Label": "Kernel act",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA31": {
          "SRC": "APP",
          "Label": "Original data elements",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA33": {
          "SRC": "APP",
          "Label": "Message Type Identifier",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA34": {
          "SRC": "APP",
          "Label": "System trace audit number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA35": {
          "SRC": "APP",
          "Label": "Processing code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA36": {
          "SRC": "APP",
          "Label": "Date time local transaction",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA38": {
          "SRC": "APP",
          "Label": "Function code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA39": {
          "SRC": "APP",
          "Label": "Message reason code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA3A": {
          "SRC": "APP",
          "Label": "Card acceptor card id",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA3B": {
          "SRC": "APP",
          "Label": "Card acceptor terminal id",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA3D": {
          "SRC": "APP",
          "Label": "Message control data elements",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA3E": {
          "SRC": "APP",
          "Label": "Security related information",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA3F": {
          "SRC": "APP",
          "Label": "ICC Related data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA40": {
          "SRC": "APP",
          "Label": "Product data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA42": {
          "SRC": "APP",
          "Label": "Retry counter",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA45": {
          "SRC": "APP",
          "Label": "Encrypted PAN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA49": {
          "SRC": "APP",
          "Label": "MSD transaction",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA65": {
          "SRC": "APP",
          "Label": "Date local transaction",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCA68": {
          "SRC": "APP",
          "Label": "IFSF field definition 32",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFCB06": {
          "SRC": "APP",
          "Label": "Alternative host url",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-DFD001": {
          "SRC": "APP",
          "Label": "EMS - Reversal record",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "APP-IFSF": {
          "SRC": "APP",
          "Label": "IFSF",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        }
      }
    }
  },
  "AUTOSCAN": {
    "primary": {
      "label": "",
      "data": {
        "AUTOSCAN-Battery Level": {
          "SRC": "AUTOSCAN",
          "Label": "Battery Level",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "AUTOSCAN-D2": {
          "SRC": "AUTOSCAN",
          "Label": "Sample length",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "BOOT": {
    "primary": {
      "label": "",
      "data": {
        "BOOT-FW Name": {
          "SRC": "BOOT",
          "Label": "FW Name",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-FW Target": {
          "SRC": "BOOT",
          "Label": "FW Target",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-FW Version": {
          "SRC": "BOOT",
          "Label": "FW Version",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-FW Date": {
          "SRC": "BOOT",
          "Label": "FW Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-Status": {
          "SRC": "BOOT",
          "Label": "Status",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "Translate to hard/soft reboot"
        },
        "BOOT-Error": {
          "SRC": "BOOT",
          "Label": "Error",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-Source": {
          "SRC": "BOOT",
          "Label": "Source",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-DB": {
          "SRC": "BOOT",
          "Label": "FS check required",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-DC": {
          "SRC": "BOOT",
          "Label": "FS check result",
          "Overview": 0,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "This one is only present if the file system check is done"
        },
        "BOOT-DD": {
          "SRC": "BOOT",
          "Label": "Mount result",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-D8": {
          "SRC": "BOOT",
          "Label": "Flash vendor",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-D9": {
          "SRC": "BOOT",
          "Label": "Flash device",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "BOOT-DA": {
          "SRC": "BOOT",
          "Label": "Flash size",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "CARDEDGE": {
    "primary": {
      "label": "",
      "data": {
        "CARDEDGE-Total Memory": {
          "SRC": "CARDEDGE",
          "Label": "Total Memory",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CARDEDGE-Free Memory": {
          "SRC": "CARDEDGE",
          "Label": "Free Memory",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CARDEDGE-Used Key": {
          "SRC": "CARDEDGE",
          "Label": "Used Key",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CARDEDGE-Used PIN": {
          "SRC": "CARDEDGE",
          "Label": "Used PIN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CARDEDGE-CE SW Version": {
          "SRC": "CARDEDGE",
          "Label": "CE SW Version",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CARDEDGE-CE Version": {
          "SRC": "CARDEDGE",
          "Label": "CE Version",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "CCI": {
    "primary": {
      "label": "",
      "data": {
        "CCI-Type": {
          "SRC": "CCI",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CCI-Amount": {
          "SRC": "CCI",
          "Label": "Amount",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CCI-Item Nr": {
          "SRC": "CCI",
          "Label": "Item Nr",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "CCI-PTOS Result": {
          "SRC": "CCI",
          "Label": "PTOS Result",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "DEBUG": {
    "primary": {
      "label": "",
      "data": {
        "DEBUG-Log": {
          "SRC": "DEBUG",
          "Label": "Log",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "ETHERNET": {
    "primary": {
      "label": "",
      "data": {
        "ETHERNET-D2": {
          "SRC": "ETHERNET",
          "Label": "IP address",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D3": {
          "SRC": "ETHERNET",
          "Label": "Netmask",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D4": {
          "SRC": "ETHERNET",
          "Label": "Gateway",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D5": {
          "SRC": "ETHERNET",
          "Label": "DNS3",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D6": {
          "SRC": "ETHERNET",
          "Label": "DNS4",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D7": {
          "SRC": "ETHERNET",
          "Label": "DNS5",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-D8": {
          "SRC": "ETHERNET",
          "Label": "DNS6",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "ETHERNET-State": {
          "SRC": "ETHERNET",
          "Label": "State",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "GPRS": {
    "primary": {
      "label": "",
      "data": {
        "GPRS-Operator": {
          "SRC": "GPRS",
          "Label": "Operator",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-CCID": {
          "SRC": "GPRS",
          "Label": "CCID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "In MyPayter there are know two tags: Sim and CCID"
        },
        "GPRS-Signal": {
          "SRC": "GPRS",
          "Label": "Signal",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-Signal History": {
          "SRC": "GPRS",
          "Label": "Signal strength history",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-GSN": {
          "SRC": "GPRS",
          "Label": "GSN",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-CIMI": {
          "SRC": "GPRS",
          "Label": "CIMI",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-DB": {
          "SRC": "GPRS",
          "Label": "Local Area Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "**-Use to determine location"
        },
        "GPRS-DC": {
          "SRC": "GPRS",
          "Label": "Cell ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "**-Use to determine location"
        },
        "GPRS-DD": {
          "SRC": "GPRS",
          "Label": "Signal strength history",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-DE": {
          "SRC": "GPRS",
          "Label": "IMEI",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-Error": {
          "SRC": "GPRS",
          "Label": "Error",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F1": {
          "SRC": "GPRS",
          "Label": "Revision",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F2": {
          "SRC": "GPRS",
          "Label": "Serial",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F3": {
          "SRC": "GPRS",
          "Label": "Act code",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "***-Translate to UMT etc"
        },
        "GPRS-F4": {
          "SRC": "GPRS",
          "Label": "RAC",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F5": {
          "SRC": "GPRS",
          "Label": "BER",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F6": {
          "SRC": "GPRS",
          "Label": "ECNO",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F7": {
          "SRC": "GPRS",
          "Label": "Baudrate",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F8": {
          "SRC": "GPRS",
          "Label": "Auto baud method",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-F9": {
          "SRC": "GPRS",
          "Label": "Original baudrate",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-FA": {
          "SRC": "GPRS",
          "Label": "Error message",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-FB": {
          "SRC": "GPRS",
          "Label": "DNS1",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-FC": {
          "SRC": "GPRS",
          "Label": "DNS2",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-Rx Data": {
          "SRC": "GPRS",
          "Label": "Rx Bytes",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-Tx Data": {
          "SRC": "GPRS",
          "Label": "Tx Bytes",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-Session": {
          "SRC": "GPRS",
          "Label": "Session",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "GPRS-State": {
          "SRC": "GPRS",
          "Label": "State",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "LOG": {
    "primary": {
      "label": "",
      "data": {
        "LOG-Type": {
          "SRC": "LOG",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "LOG-PTOS Result": {
          "SRC": "LOG",
          "Label": "PTOS Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "LOG-Flash Error": {
          "SRC": "LOG",
          "Label": "Flash Error",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "MDB": {
    "primary": {
      "label": "",
      "data": {
        "MDB-State": {
          "SRC": "MDB",
          "Label": "State",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Type": {
          "SRC": "MDB",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Master TX": {
          "SRC": "MDB",
          "Label": "Master TX",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "****-Translate to readable data in Elastic"
        },
        "MDB-Master RX": {
          "SRC": "MDB",
          "Label": "Master RX",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "****-Translate to readable data in Elastic"
        },
        "MDB-Amount": {
          "SRC": "MDB",
          "Label": "Amount",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Item Nr": {
          "SRC": "MDB",
          "Label": "Item Nr",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Cmd": {
          "SRC": "MDB",
          "Label": "Cmd",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-D9": {
          "SRC": "MDB",
          "Label": "D9",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-DA": {
          "SRC": "MDB",
          "Label": "DA",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Data": {
          "SRC": "MDB",
          "Label": "Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Dup Cnt": {
          "SRC": "MDB",
          "Label": "Dup Cnt",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "MDB-Reason": {
          "SRC": "MDB",
          "Label": "Reason",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "MDB_GAT": {
    "primary": {"label": "", "data": {}},
    "others": {
      "data": {
        "MDB_GAT-tmp": {
          "SRC": "MDB_GAT",
          "Label": "Placeholder",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "Placeholder for MDB_GAT events"
        }
      }
    }
  },
  "PSP": {
    "primary": {
      "label": "",
      "data": {
        "PSP-State": {
          "SRC": "PSP",
          "Label": "State",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Type": {
          "SRC": "PSP",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Cmd": {
          "SRC": "PSP",
          "Label": "Cmd",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Reason": {
          "SRC": "PSP",
          "Label": "Reason",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Master TX": {
          "SRC": "PSP",
          "Label": "Master TX",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Master RX": {
          "SRC": "PSP",
          "Label": "Master RX",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "PVP": {
    "primary": {
      "label": "",
      "data": {
        "PSP-Amount": {
          "SRC": "PVP",
          "Label": "Amount",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PSP-Dup Cnt": {
          "SRC": "PVP",
          "Label": "Dup Cnt",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-State": {
          "SRC": "PVP",
          "Label": "State",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 1,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Type": {
          "SRC": "PVP",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Cmd": {
          "SRC": "PVP",
          "Label": "Cmd",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Reason": {
          "SRC": "PVP",
          "Label": "Reason",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Amount": {
          "SRC": "PVP",
          "Label": "Amount",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Dup Cnt": {
          "SRC": "PVP",
          "Label": "Dup Cnt",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "PVP-Master RX": {
          "SRC": "PVP",
          "Label": "Master RX",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "****-Translate to readable data in Elastic"
        },
        "PVP-Master TX": {
          "SRC": "PVP",
          "Label": "Master TX",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "****-Translate to readable data in Elastic"
        }
      }
    },
    "others": {"data": {}}
  },
  "SAM": {
    "primary": {
      "label": "",
      "data": {
        "SAM-Slot": {
          "SRC": "SAM",
          "Label": "Slot",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SAM-Serial": {
          "SRC": "SAM",
          "Label": "Serial",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SAM-Applets": {
          "SRC": "SAM",
          "Label": "Applets",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SAM-Card Id": {
          "SRC": "SAM",
          "Label": "Card Id",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SAM-PTOS Result": {
          "SRC": "SAM",
          "Label": "PTOS Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SAM-ATR": {
          "SRC": "SAM",
          "Label": "ATR",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "SPY": {
    "primary": {
      "label": "",
      "data": {
        "SPY-Reason": {
          "SRC": "SPY",
          "Label": "Reason",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "SPY-Error Cnt": {
          "SRC": "SPY",
          "Label": "Error Count",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "TCPIP": {
    "primary": {
      "label": "",
      "data": {
        "TCPIP-Error": {
          "SRC": "TCPIP",
          "Label": "Error",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-DFCA01": {
          "SRC": "TCPIP",
          "Label": "Recover network reason",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-RX Data": {
          "SRC": "TCPIP",
          "Label": "RX Bytes",
          "Overview": 0,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-TX Data": {
          "SRC": "TCPIP",
          "Label": "TX Bytes",
          "Overview": 0,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-Host": {
          "SRC": "TCPIP",
          "Label": "Host",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-D5": {
          "SRC": "TCPIP",
          "Label": "Local IP",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-D6": {
          "SRC": "TCPIP",
          "Label": "Local Port",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-D7": {
          "SRC": "TCPIP",
          "Label": "Remote IP",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TCPIP-D8": {
          "SRC": "TCPIP",
          "Label": "Remote Port",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "TMS": {
    "primary": {
      "label": "",
      "data": {
        "TMS-Failed": {
          "SRC": "TMS",
          "Label": "Failed",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TMS-Attempts": {
          "SRC": "TMS",
          "Label": "Attempts",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TMS-D4": {
          "SRC": "TMS",
          "Label": "Consecutive failed",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TMS-Sync Time": {
          "SRC": "TMS",
          "Label": "Sync Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {"data": {}}
  },
  "TXN": {
    "primary": {
      "label": "",
      "data": {
        "TXN-Txn ID": {
          "SRC": "TXN",
          "Label": "Txn ID",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-IFD Type": {
          "SRC": "TXN",
          "Label": "IFD Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Type": {
          "SRC": "TXN",
          "Label": "Type",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Authorised Amount": {
          "SRC": "TXN",
          "Label": "Authorised",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Capture Amount": {
          "SRC": "TXN",
          "Label": "Capture",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Currency Code": {
          "SRC": "TXN",
          "Label": "Currency",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Brand": {
          "SRC": "TXN",
          "Label": "Brand",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-D9": {
          "SRC": "TXN",
          "Label": "Error text",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-5A": {
          "SRC": "TXN",
          "Label": "EMV - PAN",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*****-Only for proprietary, maybe only use other tag"
        },
        "TXN-5FE001": {
          "SRC": "TXN",
          "Label": "PP - Command result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFDA03": {
          "SRC": "TXN",
          "Label": "Vend amount",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Host Result": {
          "SRC": "TXN",
          "Label": "Host Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-PTOS Result": {
          "SRC": "TXN",
          "Label": "PTOS Result",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Status": {
          "SRC": "TXN",
          "Label": "Status",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Authorisation Code": {
          "SRC": "TXN",
          "Label": "Authorisation Code",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Authorisation Response Code": {
          "SRC": "TXN",
          "Label": "Authorisation Response Code",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-HID": {
          "SRC": "TXN",
          "Label": "HID",
          "Overview": 1,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Online": {
          "SRC": "TXN",
          "Label": "Online",
          "Overview": 1,
          "Overview Label": 1,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-50": {
          "SRC": "TXN",
          "Label": "EMV - Application Label",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-5FE310": {
          "SRC": "TXN",
          "Label": "PP - KSN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-72": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Script Template 2",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-82": {
          "SRC": "TXN",
          "Label": "EMV - Application Interchange Profile",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-95": {
          "SRC": "TXN",
          "Label": "EMV - TVR",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9A": {
          "SRC": "TXN",
          "Label": "EMV - Transaction Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9B": {
          "SRC": "TXN",
          "Label": "EMV - TSI",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9C": {
          "SRC": "TXN",
          "Label": "EMV - Transaction Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F06": {
          "SRC": "TXN",
          "Label": "EMV - AID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F12": {
          "SRC": "TXN",
          "Label": "EMV - Application Preferred Name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F15": {
          "SRC": "TXN",
          "Label": "EMV - Merchant Category Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F1A": {
          "SRC": "TXN",
          "Label": "EMV - Terminal Country Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F1E": {
          "SRC": "TXN",
          "Label": "EMV - IFD Serial number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F21": {
          "SRC": "TXN",
          "Label": "EMV - Transaction Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F35": {
          "SRC": "TXN",
          "Label": "EMV - Terminal Type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-9F53": {
          "SRC": "TXN",
          "Label": "EMV - Contactless Card Verification Results",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-9F57": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Country Code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-9F6D": {
          "SRC": "TXN",
          "Label": "EMV - Contactless Reader Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-Card Time": {
          "SRC": "TXN",
          "Label": "Card Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DF Name": {
          "SRC": "TXN",
          "Label": "DF Name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DF49": {
          "SRC": "TXN",
          "Label": "DF49",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA09": {
          "SRC": "TXN",
          "Label": "Item ref",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA0A": {
          "SRC": "TXN",
          "Label": "Brand name",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA0E": {
          "SRC": "TXN",
          "Label": "Transaction timestamp",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA13": {
          "SRC": "TXN",
          "Label": "ICR Custom present card message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA16": {
          "SRC": "TXN",
          "Label": "KSN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA1A": {
          "SRC": "TXN",
          "Label": "Z8,Z9,Z10 priceline in MDB",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA1B": {
          "SRC": "TXN",
          "Label": "Scan display message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA29": {
          "SRC": "TXN",
          "Label": "Button confirmation options",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA2A": {
          "SRC": "TXN",
          "Label": "Insertion start",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA4A": {
          "SRC": "TXN",
          "Label": "Floor limit exceeded",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA4B": {
          "SRC": "TXN",
          "Label": "Kernel type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA4C": {
          "SRC": "TXN",
          "Label": "Authorization type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA5C": {
          "SRC": "TXN",
          "Label": "Proprietary token",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA6A": {
          "SRC": "TXN",
          "Label": "Card detect timeout",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA6B": {
          "SRC": "TXN",
          "Label": "Session ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCA70": {
          "SRC": "TXN",
          "Label": "Deferred auth",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCB0C": {
          "SRC": "TXN",
          "Label": "Capture default",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCC01": {
          "SRC": "TXN",
          "Label": "Amex level 2 display",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCC02": {
          "SRC": "TXN",
          "Label": "Offline type",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCC07": {
          "SRC": "TXN",
          "Label": "MDB Session price list",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCC08": {
          "SRC": "TXN",
          "Label": "MDB Display item list",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFCF10": {
          "SRC": "TXN",
          "Label": "BKM - Action code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD002": {
          "SRC": "TXN",
          "Label": "EMS - EMV Response data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD006": {
          "SRC": "TXN",
          "Label": "EMS - Merchant ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD007": {
          "SRC": "TXN",
          "Label": "EMS - Approval code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD008": {
          "SRC": "TXN",
          "Label": "EMS - Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD009": {
          "SRC": "TXN",
          "Label": "EMS - Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFD00A": {
          "SRC": "TXN",
          "Label": "EMS - Reversal amount",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFF001": {
          "SRC": "TXN",
          "Label": "Card start date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFF002": {
          "SRC": "TXN",
          "Label": "Card reference",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFF003": {
          "SRC": "TXN",
          "Label": "Card hash host",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFF004": {
          "SRC": "TXN",
          "Label": "Card description",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-DFF007": {
          "SRC": "TXN",
          "Label": "PAN receipt host",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Decline Message": {
          "SRC": "TXN",
          "Label": "Decline Message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Deferred Auth Flag": {
          "SRC": "TXN",
          "Label": "Deferred Auth Flag",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Error Indicator": {
          "SRC": "TXN",
          "Label": "Error Indicator",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Extra TXN ID": {
          "SRC": "TXN",
          "Label": "Extra TXN ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Host Txn ID": {
          "SRC": "TXN",
          "Label": "Host Txn ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Masked PAN": {
          "SRC": "TXN",
          "Label": "Masked PAN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Message": {
          "SRC": "TXN",
          "Label": "Message",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Terminal Card Hash": {
          "SRC": "TXN",
          "Label": "Terminal Card Hash",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Txn Time": {
          "SRC": "TXN",
          "Label": "Txn Time",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        },
        "TXN-Unpredictable Number": {
          "SRC": "TXN",
          "Label": "Unpredictable Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 1,
          "Hidden": 0
        }
      }
    },
    "others": {
      "data": {
        "TXN-56": {
          "SRC": "TXN",
          "Label": "EMV - Track 1 equivalent data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-57": {
          "SRC": "TXN",
          "Label": "EMV - Track 2 equivalent data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "******-Sensitive"
        },
        "TXN-5F24": {
          "SRC": "TXN",
          "Label": "EMV - Application Expiration Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-5F25": {
          "SRC": "TXN",
          "Label": "EMV - Application Effective Date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-5F34": {
          "SRC": "TXN",
          "Label": "EMV - PAN Sequence Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-5FE000": {
          "SRC": "TXN",
          "Label": "PP - Command ID",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-5FE311": {
          "SRC": "TXN",
          "Label": "PP - Encrypted card holder data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-5FE33A": {
          "SRC": "TXN",
          "Label": "PP - 5FE33A (Unknown)",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-7FE320": {
          "SRC": "TXN",
          "Label": "PP - Amount entry",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-7FE340": {
          "SRC": "TXN",
          "Label": "PP - PMS data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-81": {
          "SRC": "TXN",
          "Label": "EMV - Amount, Authorised (Binary)",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-8E": {
          "SRC": "TXN",
          "Label": "EMV - CVM List",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-91": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Authentication Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F04": {
          "SRC": "TXN",
          "Label": "EMV - Amount, Other (Binary)",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F05": {
          "SRC": "TXN",
          "Label": "EMV - Application Discretionary Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F07": {
          "SRC": "TXN",
          "Label": "EMV - Application Usage Control",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F09": {
          "SRC": "TXN",
          "Label": "EMV - Application Version Number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F0D": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Action Code - Default",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F0E": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Action Code - Denial",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F0F": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Action Code - Online",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F10": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Application Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F11": {
          "SRC": "TXN",
          "Label": "EMV - Issuer Code Table Index",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F26": {
          "SRC": "TXN",
          "Label": "EMV - Application Cryptogram",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F27": {
          "SRC": "TXN",
          "Label": "EMV - Cryptogram Information Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F33": {
          "SRC": "TXN",
          "Label": "EMV - Terminal Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F34": {
          "SRC": "TXN",
          "Label": "EMV - CVM Results",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F36": {
          "SRC": "TXN",
          "Label": "EMV - Application Transaction Counter (ATC)",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F39": {
          "SRC": "TXN",
          "Label": "EMV - Point-of-Service (POS) Entry Mode",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F40": {
          "SRC": "TXN",
          "Label": "EMV - Additional Terminal Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-9F66": {
          "SRC": "TXN",
          "Label": "EMV - Terminal Transaction Qualifiers",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-9F6B": {
          "SRC": "TXN",
          "Label": "EMV - Track 2 equiavelent Data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-9F6E": {
          "SRC": "TXN",
          "Label": "EMV - Enhanced Contactless Reader Capabilities",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-9F7C": {
          "SRC": "TXN",
          "Label": "EMV - Customer Exclusive Data ",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "*******-Data from internet"
        },
        "TXN-DF02": {
          "SRC": "TXN",
          "Label": "DF02",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DF12": {
          "SRC": "TXN",
          "Label": "DF12",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DF19": {
          "SRC": "TXN",
          "Label": "DF19",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DF48": {
          "SRC": "TXN",
          "Label": "DF48",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DF52": {
          "SRC": "TXN",
          "Label": "DF52",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DF54": {
          "SRC": "TXN",
          "Label": "DF54",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA0D": {
          "SRC": "TXN",
          "Label": "Auth entity",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA0F": {
          "SRC": "TXN",
          "Label": "Expiry date",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA12": {
          "SRC": "TXN",
          "Label": "ICR allowed",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA1D": {
          "SRC": "TXN",
          "Label": "App BHV",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA27": {
          "SRC": "TXN",
          "Label": "Track3",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0,
          "Notes": "******-Sensitive"
        },
        "TXN-DFCA2C": {
          "SRC": "TXN",
          "Label": "Kernel act",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA33": {
          "SRC": "TXN",
          "Label": "Message Type Identifier",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA34": {
          "SRC": "TXN",
          "Label": "System trace audit number",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA35": {
          "SRC": "TXN",
          "Label": "Processing code",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA36": {
          "SRC": "TXN",
          "Label": "Date time local transaction",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA3A": {
          "SRC": "TXN",
          "Label": "Card acceptor card id",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA3B": {
          "SRC": "TXN",
          "Label": "Card acceptor terminal id",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA3E": {
          "SRC": "TXN",
          "Label": "Security related information",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA40": {
          "SRC": "TXN",
          "Label": "Product data",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA45": {
          "SRC": "TXN",
          "Label": "Encrypted PAN",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA49": {
          "SRC": "TXN",
          "Label": "MSD transaction",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA67": {
          "SRC": "TXN",
          "Label": "IFSF field definition 62",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCA68": {
          "SRC": "TXN",
          "Label": "IFSF field definition 32",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFCB06": {
          "SRC": "TXN",
          "Label": "Alternative host url",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-DFD001": {
          "SRC": "TXN",
          "Label": "EMS - Reversal record",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-FFCA04": {
          "SRC": "TXN",
          "Label": "FFCA04",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        },
        "TXN-Transaction Currency Exponent": {
          "SRC": "TXN",
          "Label": "Transaction Currency Exponent",
          "Overview": 0,
          "Overview Label": 0,
          "Overview Detail": 0,
          "Overview Detail Label": 0,
          "Show missing": 0,
          "Primary": 0,
          "Hidden": 0
        }
      }
    }
  }
}
